import { FIXED_MARKER, IOCoords } from 'pages/special/OrienteeringPage/OConfig';
import { useRef } from 'react';
import {
    getInScale,
    GiveMeMap,
    IPinWorldMarker,
    IViewportExtended,
    ORIGIN_ZOOM
} from 'react-give-me-map';
import { MapRef, Marker } from 'react-map-gl';
import styled from 'styled-components/macro';

interface Props {
    viewport: IViewportExtended;
    onViewportChange: (viewport: IViewportExtended) => void;
    onCoordinatesChange: (coordinates: IOCoords[]) => void;
    activeCoordinate: number;
    coordinates: IOCoords[];
    className?: string;
}

export const ORightMap = (props: Props): JSX.Element => {
    const mapRef2 = useRef<MapRef>(null);
    const viewport2 = props.viewport;
    const imageRef = useRef(null);

    const markers = [
        ...props.coordinates.map((c, index) => {
            return {
                id: (c.hiddenLat + c.hiddenLng).toString(),
                lat: c.hiddenLat,
                lng: c.hiddenLng,
                selectable: true,
                visible: true,
                elementType: 'pin',
                elementData: {
                    label: index.toString(),
                    img: '',
                    emoji: '',
                    dotColor: 'CC4D36',
                    icon: null
                },
                scalable: false,
                order: 2
            } as IPinWorldMarker;
        })
    ];

    const adjustedScale = getInScale(FIXED_MARKER.scale as number, ORIGIN_ZOOM, viewport2.zoom);

    return (
        <S_ORightMap className={props.className}>
            <GiveMeMap
                mapRef={mapRef2}
                map={{
                    ...(viewport2.latitude != null ? { latitude: viewport2.latitude } : {}),
                    ...(viewport2.longitude != null ? { longitude: viewport2.longitude } : {}),
                    ...(viewport2.zoom != null ? { zoom: viewport2.zoom } : {}),
                    mapboxAccessToken: process.env.REACT_APP_MAPBOX_TOKEN,
                    onMove: (v) => {
                        props.onViewportChange({
                            latitude: v.viewState.latitude,
                            longitude: v.viewState.longitude,
                            zoom: v.viewState.zoom
                        });
                    },
                    onClick: (e) => {
                        console.log('Click', e.lngLat);
                        const newCoordinates = [...props.coordinates];
                        newCoordinates[props.activeCoordinate] = {
                            ...newCoordinates[props.activeCoordinate],
                            hiddenLat: e.lngLat.lat,
                            hiddenLng: e.lngLat.lng
                        };
                        props.onCoordinatesChange(newCoordinates);
                    },
                    onLoad: (e) => {
                        console.log('Load', e);
                    }
                }}
                callbacks={{
                    onMarkersSelected: (e) => {
                        console.log('Marker', e);
                    }
                }}
                config={{
                    availableStyles: ['mapbox://styles/koudelka/cld4qatdp001e01pglhbqhffx']
                }}
                markers={markers}
            >
                <Marker longitude={FIXED_MARKER.lng} latitude={FIXED_MARKER.lat}>
                    <div
                        ref={imageRef}
                        style={{
                            transform: `rotate(${FIXED_MARKER.rotate}deg)`,
                            pointerEvents: FIXED_MARKER.selectable ? 'all' : 'none',
                            cursor: FIXED_MARKER.selectable ? 'pointer' : 'inherit'
                        }}
                    >
                        <S_Image
                            onClick={(e) => {
                                const target = e.target as HTMLImageElement;
                                const clientHeight = target.clientHeight;
                                const clientWidth = target.clientWidth;
                                const naturalHeight = target.naturalHeight;
                                const naturalWidth = target.naturalWidth;
                                console.log(
                                    'Client height: ' +
                                        clientHeight +
                                        ' Client width: ' +
                                        clientWidth +
                                        ' Natural height: ' +
                                        naturalHeight +
                                        ' Natural width: ' +
                                        naturalWidth +
                                        ''
                                );
                                //get position where in the image the click happened
                                const x = e.nativeEvent.offsetX;
                                const y = e.nativeEvent.offsetY;
                                console.log('x: ' + x + ' y: ' + y);
                                //get the position in the image in percentage
                                const xPercent = (x / clientWidth) * 100;
                                const yPercent = (y / clientHeight) * 100;
                                console.log('x%: ' + xPercent + ' y%: ' + yPercent);
                                const newCoordinates = [...props.coordinates];
                                newCoordinates[props.activeCoordinate] = {
                                    ...newCoordinates[props.activeCoordinate],
                                    xPercent,
                                    yPercent
                                };
                                props.onCoordinatesChange(newCoordinates);
                            }}
                            width={250 * adjustedScale}
                            src={FIXED_MARKER.elementData.src}
                        />
                    </div>
                </Marker>
            </GiveMeMap>
        </S_ORightMap>
    );
};

const S_ORightMap = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
`;

const S_Image = styled.img`
    width: ${(props) => props.width}px;
`;
